import 'babel-polyfill';
import 'utils/extensions';

import * as seazit from './seazit';

window.apps.seazit = seazit;


// WEBPACK FOOTER //
// ./seazit/assets/index.js